import classes from "./Footer.module.css";
const Footer = () => {
  return (
    <>
      <div className={classes.footer}>
        <h3>Develop by Manish Tomar</h3>
        <p>© 2023 MS Software. All rights reserved.</p>
      </div>
    </>
  );
};

export default Footer;
